import nsiLogo from "./nsi-logo.png";
import nsiLogoWhite from "./nsi_logo_white.png";
import placeholderPerson from "./placeholder-person.png";
import placeholderImage from "./image_placeholder.png";
import zhcLogo from "./zhc-logo.png";

const assets = {
  images: {
    zhcLogo: zhcLogo,
    nsiLogo: nsiLogo,
    nsiLogoWhite: nsiLogoWhite,
    placeholderPerson: placeholderPerson,
    placeholderImage: placeholderImage,
  },
};

export default assets;
